import React from 'react'
import { baseUrl } from '@fs/zion-config'
import { DocumentRecordSearch } from '@fs/zion-icon'
import { useTranslation } from 'react-i18next'

import BaseOfferCard from './BaseOfferCard'

export default function RecordsCard() {
  const { t } = useTranslation()

  return (
    <BaseOfferCard
      data-testid="records-card"
      title={t('apac.nlihp.offers.records-card.heading', 'Search Records')}
      description={t(
        'apac.nlihp.offers.records-card.subheading',
        'Search billions of historical genealogy records for free.'
      )}
      Icon={DocumentRecordSearch}
      to={`${baseUrl}/search/discovery`}
      external
      linkName="button: search-records: click"
    />
  )
}
